import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import FastTextArea from '../util/FastTextArea';
import FastFormQuestion from "../util/FastFormQuestion";
import FORM_QUESTIONS from '../../step5_tab2_questions.json';

export default function PlanAssessmentForm(props) {
    let programId = props.selectedProgram?.programId
    let sloId = props.selectedLearningOutcome?.sloId

    let step2Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step2DataStore) {
        let step2DataBySlo = props.step2DataStore[programId]
        if (sloId in step2DataBySlo) {
            step2Data = step2DataBySlo[sloId]
        }
    }

    let step4Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step4DataStore) {
        let step4DataBySlo = props.step4DataStore[programId]
        if (sloId in step4DataBySlo) {
            step4Data = step4DataBySlo[sloId]
        }
    }
    
    let step5Tab1Data = {
        "s5q1": "",
        "s5q2": "",
        "s5q3": "",
        "s5q4": "",
        "s5q5": "",
        "s5q14": "",
    }
    if (programId in props.step5Tab1DataStore) {
        let step5Tab1DataBySlo = props.step5Tab1DataStore[programId]
        if (sloId in step5Tab1DataBySlo) {
            step5Tab1Data = step5Tab1DataBySlo[sloId]
        }
    }
    
    return (
        <React.Fragment>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Department
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.department.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Program
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.selectedProgram?.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Theme
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.theme ? props.theme.name : 'Unavailable'}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Learning Outcome
                    </Form.Label>
                    <Col sm="8">
                        <Form.Select 
                            aria-label="Select Learning Outcome"
                            onChange={props.handleLearningOutcomeChanged}
                            name={'program-' + props.selectedProgram?.programId + '_slo-' + props.selectedLearningOutcome?.sloId}
                            value={props.selectedLearningOutcome?.sloId}
                            >
                            { props.selectedProgram &&
                                props.learningOutcomes[props.selectedProgram.programId].map((slo, key) => 
                                    <option key={key} value={slo.sloId}>{slo.text}</option>
                                )
                            }
                        </Form.Select>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Focus Area
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            { props.selectedProgram &&
                                props.step1DataStore[props.selectedProgram.programId][props.selectedLearningOutcome?.sloId]?.s1q1}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Courses Assessed in First Round
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step2Data.coursesAssessed}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Interpretation of first round results
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step4Data.interpretationOfResults}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["secondRoundToolDescription"].text}
                            required={FORM_QUESTIONS["secondRoundToolDescription"].required}
                            />
                    </Form.Label>
                    <Col sm="8">
                        <FastTextArea
                            id="s5q17"
                            callback={props.handleS5Q17Changed}
                            text={props.stepData.s5q17}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="512"
                            />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["secondRoundCoursesAssessed"].text}
                            required={FORM_QUESTIONS["secondRoundCoursesAssessed"].required}
                            />
                    </Form.Label>
                    <Col sm="8">
                        <FastTextArea
                            id="s5q18"
                            callback={props.handleS5Q18Changed}
                            text={props.stepData.s5q18}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="512"
                            />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["brightspaceAutomation"].text}
                            required={FORM_QUESTIONS["brightspaceAutomation"].required}
                            />
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            <Form.Select 
                                name="s5q19"
                                aria-label="Will use Brightspace automation"
                                value={props.stepData.s5q19}
                                onChange={props.handleS5Q19Changed}
                                disabled={props.formDisabled}
                                >
                                <option></option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                                <option value="maybe">Maybe</option>
                            </Form.Select>
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Col} className="pt-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["secondRoundDataCollection"].text}
                            required={FORM_QUESTIONS["secondRoundDataCollection"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q20"
                            callback={props.handleS5Q20Changed}
                            text={props.stepData.s5q20}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="512"
                            />
                    </Row>
                </Form.Group>
            </Form>
        </React.Fragment>
    )
}